import { getAuthToken } from "auth/authToken";
import { MainContent } from "components/Layout/components/Content";
import { Header, HeaderProps } from "components/Layout/components/Header/Header";
import { MasterLayout } from "components/Layout/components/MasterLayout";
import { SideBar } from "components/Layout/components/SideBar";
import { SupportedApps } from "config/config";
import { useApp } from "hooks/useApp";
import { useEnsureAuthenticated } from "hooks/useEnsureAuthenticated";
import React from "react";

const Menu = React.lazy(() => import("provisioningportalapp/Menu"));
const AppRouter = React.lazy(() => import("provisioningportalapp/AppRouter"));
const EnvironmentProvider = React.lazy(() => import("provisioningportalapp/EnvironmentProvider"));

type ProvisioningPortalContainerType = {
    headerProps: HeaderProps;
    unauthenticatedHandler: (back: string) => void;
};

export const ProvisioningPortalContainer = ({ headerProps, unauthenticatedHandler }: ProvisioningPortalContainerType) => {
    const ensureAuthenticated = useEnsureAuthenticated();
    const authToken = getAuthToken();
    const hasRole = (_role: string) => {
        return true;
    };

    const provisioningPortalApp = useApp(SupportedApps.provisioningPortal);

    return (
        provisioningPortalApp.isLoaded() !== undefined && (
            <EnvironmentProvider
                authToken={authToken}
                containerVersion={APP_INFO.VERSION}
                configuration={provisioningPortalApp.configuration}
                ensureAuthenticated={ensureAuthenticated}
                hasRole={hasRole}
                unauthenticatedHandler={unauthenticatedHandler}
            >
                <MasterLayout>
                    <Header appTitle={headerProps.appTitle} username={headerProps.username} userProfile={headerProps.userProfile} />
                    <SideBar>
                        <Menu />
                    </SideBar>
                    <MainContent id="pageContent">
                        <AppRouter />
                    </MainContent>
                </MasterLayout>
            </EnvironmentProvider>
        )
    );
};
